export function getInitials(name: string): string {
  return name?.trim()?.[0]?.toUpperCase() ?? '?';
}
